import { render, staticRenderFns } from "./ordersModal.vue?vue&type=template&id=03f96f72&scoped=true"
import script from "./ordersModal.vue?vue&type=script&lang=js"
export * from "./ordersModal.vue?vue&type=script&lang=js"
import style0 from "./ordersModal.vue?vue&type=style&index=0&id=03f96f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f96f72",
  null
  
)

export default component.exports